import { useQuery } from "@tanstack/react-query";

import { getLastMeasurements } from "~/api/lastMeasurements";
import type { LastMeasurements } from "~/api/lastMeasurements";

interface UseLastMeasurementsReturn {
  data: LastMeasurements | undefined;
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<unknown>;
}

export const useLastMeasurements = (
  patientId: number,
): UseLastMeasurementsReturn => {
  const { data, isLoading, error, refetch } = useQuery({
    queryFn: () => getLastMeasurements(patientId),
    queryKey: ["lastMeasurements", { patientId }],
    enabled: !!patientId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 3,
  });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
